<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="model.id ? '编辑' : (pageType ? '新建一级' : '新建')"
      width="500px"
      top="5vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="model"
        class="form"
        label-width="80px">
      <el-form-item label="序号" prop="typeIndex" :rules="$rule.notNull">
        <el-input v-model.number="model.typeIndex" type="number" min="1" placeholder="请输入"/>
      </el-form-item>
      <el-form-item label="名称" prop="typeName" :rules="$rule.notNull">
        <el-input v-model.trim="model.typeName" placeholder="请输入"/>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible=false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
    </span>
  </el-dialog>
</template>
<script>
  export default {
    name: "VmTreeTypeEdit",
    props: {
      category: {
        type: Number,
        required: true,
      },
    },
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        pageType: 0,
        model: {
          id: "",
          category: this.category,
          typeIndex: "",
          orderIndex: "",
          typeName: "",
          parentId: "",
        },
      };
    },
    methods: {
      open(pageType, id, parentId, index) {
        this.pageType = pageType;
        this.model.id = id;
        this.model.parentId = parentId;
        this.model.typeIndex = index;
        this.dialogVisible = true;
        if (id > 0) {
          this.getData();
        }
      },
      getData() {
        this.contentLoading = true;
        let param = {
          category: this.model.category,
        };
        this.$http
          .get("basic", `treeTypes/${this.model.id}`, param)
          .then(resp => {
            this.model = resp;
          }).finally(() => {
            this.contentLoading = false;
          });
      },
      handleSubmit() {
        this.submitLoading = true;
        this.$http
          .save("basic", "treeTypes", this.model)
          .then(() => {
            this.dialogVisible = false;
            this.$emit("save-success");
            this.$message.success("保存成功");
          })
          .finally(() => {
            this.submitLoading = false;
          });
      },
    },
  };
</script>

<style scoped>
</style>
